<template>
    <form :action="urls.properties">
        <input
            type="hidden"
            name="s"
            value=""
        >

        <TypeToggle
            v-model:type="type"
            class="mb-3.5"
        />

        <div class="flex flex-wrap lg:flex-nowrap gap-2.5 lg:gap-0">
            <div class="w-full lg:w-1/3 lg:pr-[5px]">
                <RegionsSelector
                    v-model:selected="regionsSelected"
                    @selected="regionsSelected = $event"
                />
            </div>

            <div class="w-full lg:w-1/3">
                <DatesSelector
                    v-model:startDate="startDate"
                    v-model:endDate="endDate"
                    @datesSelected="cacheDates($event.startDate, $event.endDate)"
                />
            </div>

            <div class="w-full lg:w-1/3 lg:pl-[5px]">
                <div class="flex gap-2.5 lg:gap-[5px]">
                    <GuestsSelector
                        v-if="type == 'stays'"
                        class="w-full"
                        v-model:guestsCount="guestsCount"
                        v-model:bedroomsCount="bedroomsCount"
                        v-model:bathroomsCount="bathroomsCount"
                    />

                    <CapacitySelector
                        v-else-if="type == 'weddings'"
                        class="w-full"
                        v-model:capacityCount="capacityCount"
                        v-model:seatedIndoorsCount="seatedIndoorsCount"
                    />

                    <button
                        class="button button-2 w-[52px] sm:w-[62px] p-0 xl:px-[26px] xl:w-auto shrink-0 filters-search"
                        aria-label="Search"
                        type="submit"
                    >
                        <span class="hidden xl:block">
                            Search
                        </span>
                        <span
                            class="size-[18px] block xl:hidden text-white"
                            v-html="searchIcon"
                        ></span>
                    </button>
                </div>
            </div>
        </div>
    </form>
</template>

<script setup>
    import searchIcon from '@img/icons/search.svg?raw';

    import { ref } from 'vue';

    import TypeToggle from '@js/src/components/TypeToggle.vue';
    import RegionsSelector from '@js/src/components/RegionsSelector.vue';
    import DatesSelector from '@js/src/components/DatesSelector.vue';
    import GuestsSelector from '@js/src/components/GuestsSelector.vue';
    import CapacitySelector from '@js/src/components/CapacitySelector.vue';

    import { cacheDates } from '@js/src/helpers';

    const urls = ref(Filters.urls);
    const type = ref(Filters.type);

    const regionsSelected = ref(Filters.regionsSelected);
    const startDate = ref(Filters.startDate);
    const endDate = ref(Filters.endDate);
    const guestsCount = ref(Filters.guestsCount);
    const bedroomsCount = ref(Filters.bedroomsCount);
    const bathroomsCount = ref(Filters.bathroomsCount);
    const capacityCount = ref(Filters.capacityCount);
    const seatedIndoorsCount = ref(Filters.seatedIndoorsCount);
</script>
